// ════════════════════════════════════════════════════════════════
// PAYWALL — Pro upgrade screen (same across all niche deployments)
// ════════════════════════════════════════════════════════════════

import React from 'react';

export function Paywall() {
  const handleUpgrade = () => {
    // This forces the button to open your live Stripe page directly, bypassing the broken code
    window.location.href = 'https://buy.stripe.com/00w6oHebd4f9cxQgaX87K09';
  };

  return (
    <div style={{ padding: '40px', backgroundColor: '#0f172a', color: 'white', textAlign: 'center', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>Upgrade to Pro</h2>
      <p style={{ color: '#94a3b8', marginBottom: '20px', maxWidth: '400px' }}>
        Unlock unlimited wallets, assets, addresses, and remove all advertisements.
      </p>
      <button 
        onClick={handleUpgrade}
        style={{ backgroundColor: '#3b82f6', color: 'white', padding: '12px 24px', borderRadius: '8px', border: 'none', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}
      >
        Buy Pro — $7.99
      </button>
    </div>
  );
}
